import React from 'react'
import { Button, DialogueBox } from 'components/UIElements'
import { FALLBACK_STRINGS } from 'utils/constants'

const ConsentCompletedView = ({
  consentName,
  onOnboard,
  humiIsabellaDisabled,
  strings
}) => {
  const heading = strings?.consent_completed_heading || FALLBACK_STRINGS.consent_completed_heading
  const messagePrefix = strings?.consent_completed_message_prefix || FALLBACK_STRINGS.consent_completed_message_prefix
  const messageSuffix = strings?.consent_completed_message_suffix || FALLBACK_STRINGS.consent_completed_message_suffix
  const doneButtonText = strings?.consent_completed_done_button || FALLBACK_STRINGS.consent_completed_done_button

  const formattedMessage = `${messagePrefix} ${consentName || ''} ${messageSuffix}`

  return (
    <DialogueBox
      className='dialogue has-humi no-min-height'
      hasHumi={!humiIsabellaDisabled}>
      <h3>{heading}</h3>
      <p>{formattedMessage}</p>
      <Button
        content={doneButtonText}
        primary
        onClick={e => {
          e.stopPropagation()
          onOnboard()
        }}
        type='button'
      />
    </DialogueBox>
  )
}

export default ConsentCompletedView
